module.exports = __webpack_public_path__ + "img/17.19f1a9f5.png";